import axios from "axios"
if (localStorage.getItem("userAuthEtudiant")) {
  var userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))
  var token = userAuthEtudiant.user.api_token
}
if (localStorage.getItem("anneeScolaire")) {
  var anneeScolaire = JSON.parse(localStorage.getItem("anneeScolaire"))
  var annee = anneeScolaire.Annee.id
}
export default axios.create({
  withCredentials: true,
  baseURL: `https://flshs.scolarite.backcresus-institut.ovh/api/`,
  headers: {
    Authorization: `Bearer ${token}`,
    apipassword: "3KbmGc5tZhuDbPtb",
    'X-Frame-Options': 'DENY',
    "Access-Control-Allow-Origin":"*",
    annee:annee
  },
})
